import { Box, Button, Stack, Typography } from "@mui/material";
import { getYear, isAfter, setYear } from "date-fns";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// import { YearMonthRangePickerProps } from ".";
import { YearSelect } from "../YearSelect";
import MonthRangePicker from "./MonthRangePicker";
import { valueFormater } from "./valueFormater";

const YearMonthRangePopover = ({
	value,
	maxDate,
	minDate,
	dateFormater,
	confirmText = "Ok",
	curYearText = "current_year", // translation key
	onChange,
}) => {
	const { t } = useTranslation();
	const [startValue, setStartValue] = useState(() => value?.[0] ?? new Date());
	const [endValue, setEndValue] = useState(() => value?.[1] ?? new Date());

	useEffect(() => {
		if (value) {
			setStartValue(value[0]);
			setEndValue(value[1]);
		}
	}, [value]);

	return (
		<Box sx={{ p: 2 }}>
			<Typography variant="h5" align="center">
				{valueFormater(dateFormater, [startValue, endValue])}
			</Typography>
			<Stack
				direction="row"
				justifyContent="space-around"
				spacing={2}
				sx={{ my: 2 }}
			>
				<YearSelect
					minYear={minDate.getFullYear()}
					maxYear={endValue.getFullYear()}
					value={startValue.getFullYear()}
					onChange={(v) => {
						const newStatValue = setYear(startValue, v);
						if (isAfter(newStatValue, endValue)) {
							setStartValue(endValue);
							setEndValue(newStatValue);
						} else {
							setStartValue(newStatValue);
						}
					}}
				/>
				<YearSelect
					minYear={startValue.getFullYear()}
					maxYear={maxDate.getFullYear()}
					value={endValue.getFullYear()}
					onChange={(v) => {
						const newEndValue = setYear(endValue, v);
						if (isAfter(startValue, newEndValue)) {
							setEndValue(startValue);
							setStartValue(newEndValue);
						} else {
							setEndValue(newEndValue);
						}
					}}
				/>
			</Stack>
			<MonthRangePicker
				dateFormater={dateFormater}
				value={[startValue, endValue]}
				onChange={([start, end]) => {
					setStartValue(start);
					setEndValue(end);
				}}
			/>
			<Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
				<Button
					variant="text"
					onClick={() => {
						let year = getYear(new Date());
						year = year > getYear(maxDate) ? getYear(maxDate) : year;

						onChange([new Date(year, 0), new Date(year, 11)]);
					}}
				>
					{t(curYearText)}
				</Button>
				<Button
					variant="contained"
					onClick={() => {
						onChange([startValue, endValue]);
					}}
				>
					{confirmText}
				</Button>
			</Stack>
		</Box>
	);
};

export default YearMonthRangePopover;
